import { KernAlert } from '@kern-ux-annex/kern-react-kit'
import { Navigate, Outlet, useSearchParams } from 'react-router'

import { useAdminTenants } from '../../api/hooks'
import { PLATFORM_HOME, startPath } from '../../app/area'
import { useTenantState } from '../../app/tenant'
import { Loading } from '../../components/feedback'
import { PageHeader } from '../../components/layout'
import { tenantPath } from './paths'

/** The platform is reserved to the platform administration. */
export function PlatformArea() {
  const { me } = useTenantState()
  if (!me.platformAdmin) {
    return (
      <>
        <PageHeader title="Plattform" />
        <KernAlert title="Keine Berechtigung" variant="info">
          <span>Die Plattform mit allen Kommunen ist der Plattform-Administration vorbehalten.</span>
        </KernAlert>
      </>
    )
  }
  return <Outlet />
}

/** "/": platform admins start in the platform unless they entered a municipality, members in
 * the dashboard of theirs. */
export function StartRedirect() {
  const { me, entered } = useTenantState()
  return <Navigate to={startPath({ platformAdmin: me.platformAdmin, entered })} replace />
}

/** Old links to the administration („Verwaltung“) lead into the platform; a chosen
 * municipality (``?kommune=<id>``) to its detail page. */
export function LegacyAdminRedirect() {
  const [params] = useSearchParams()
  const id = params.get('kommune')
  const tenants = useAdminTenants(Boolean(id))
  if (!id) return <Navigate to={PLATFORM_HOME} replace />
  if (tenants.isPending) return <Loading />
  const slug = tenants.data?.find((t) => t.id === id)?.slug
  return <Navigate to={slug ? tenantPath(slug) : PLATFORM_HOME} replace />
}
